import { useAuth } from 'providers/auth';

export const useProtect = () => {
  const { user, openLoginPage } = useAuth();

  const protectedFn = (fn: () => void) => {
    if (user) {
      fn();
    } else {
      openLoginPage();
    }
  };

  return protectedFn;
};
